import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "../assets/images/black-back-arrow.svg";
import MasterCard from "../assets/images/cart/master-card.svg";
import Visa from "../assets/images/cart/visa.svg";
import AmericanExpress from "../assets/images/cart/american-express.svg";
import Discover from "../assets/images/cart/discover.svg";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearMessages } from "../features/auth/authActions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatPrice } from "../helpers/helpers";
import AddCardModal from "./AddCardModal";
import { fetchUserCards } from "../features/card/cardActions";
import {
  clearOrderMessages,
  createOrder,
} from "../features/order/orderActions";
import { fetchTaxRate, fetchPromocode } from "../features/cart/cartActions";

const CartSummary = ({
  token,
  checkoutData,
  taxRate,
  promoCode,
  isCouponApplied,
  selectedCardId,
  handleBack,
}) => {
  let orderTotal = 0;
  let taxAmount = 0;
  let couponDiscountAmount = 0;
  let couponTitle = "";
  let totalItemAmount = parseFloat(
    checkoutData?.services?.reduce((sum, item) => sum + item.price, 0)
  );
  const {
    loading: orderLoading
  } = useSelector((state) => state.order);

  if (isCouponApplied) {
    if (promoCode.discount_type === 1) {
      // Percentage
      couponDiscountAmount = formatPrice(
        (totalItemAmount * parseFloat(promoCode.discount_type_value)) / 100
      );
      couponTitle = "PromoCode (" + promoCode.code + ")";
    } else {
      // Fixed
      couponDiscountAmount = parseFloat(promoCode.discount_type_value);
      couponTitle = "PromoCode (" + promoCode.code + ")";
    }
  }

  if (couponDiscountAmount > 0) {
    if (couponDiscountAmount < totalItemAmount) {
      orderTotal = formatPrice(
        parseFloat(totalItemAmount) - parseFloat(couponDiscountAmount)
      );
    }
  } else {
    orderTotal = totalItemAmount;
  }

  if (orderTotal > 0) {
    if (taxRate !== null) {
      taxAmount = formatPrice(
        (orderTotal * parseFloat(taxRate.percentage)) / 100
      );
    }
  }

  orderTotal = formatPrice(parseFloat(orderTotal) + parseFloat(taxAmount));

  const dispatch = useDispatch();
  const handleContinuePayment = () => {
    if (token) {
      if (selectedCardId === null) {
        toast.error("Please choose payment method.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        return false;
      } else {
        checkoutData.choose_services = JSON.stringify(checkoutData.services);
        checkoutData.total_item_amount = totalItemAmount;
        checkoutData.order_total = orderTotal;
        checkoutData.promocode = isCouponApplied
          ? JSON.stringify(promoCode)
          : "";
        checkoutData.promocode_discount_amount = couponDiscountAmount;
        checkoutData.tax_rate = taxAmount > 0 ? JSON.stringify(taxRate) : "";
        checkoutData.tax_amount = taxAmount;
        checkoutData.pcid = selectedCardId;

        
        dispatch(createOrder(checkoutData));
      }
    }
  };

  return (
    <div className="summary-box">
      <div className="box-header">
        <h3>Order Summary</h3>
        <p>Review your items and totals before placing your order.</p>
      </div>
      <Table>
        <tbody>
          <tr>
            <td>Items Total({checkoutData?.services?.length})</td>
            <td>$ {formatPrice(totalItemAmount)}</td>
          </tr>

          {couponDiscountAmount > 0 && (
            <tr>
              <td>{couponTitle}</td>
              <th>-${couponDiscountAmount}</th>
            </tr>
          )}

          {taxAmount > 0 && (
            <tr>
              <td>Tax</td>
              <td className="discounts">+$ {taxAmount}</td>
            </tr>
          )}

          <tr>
            <td>
              <b>Order Total</b>
            </td>
            <td>
              <b>$ {formatPrice(orderTotal)}</b>
            </td>
          </tr>
        </tbody>
      </Table>
      <div className="form-button--group">
        <Link className="custom-bttn back-bttn" onClick={() => handleBack()}>
          <img src={BackButton} alt="" /> Back
        </Link>
        {token ? (
          <Button
            disabled={orderLoading}
            className="custom-bttn green-bttn"
            onClick={() => handleContinuePayment()}
          >
            {orderLoading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="lg"
                className="spinner-icon"
              />
            ) : (
              "Continue to Payment"
            )}
          </Button>
        ) : (
          <Link className="custom-bttn green-bttn" to="/register">
            Continue to Payment{" "}
          </Link>
        )}
      </div>
    </div>
  );
};

const CheckoutComp = ({ step, handleBack }) => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const [checkoutData, setCheckoutData] = useState("");
  const [showAddCardModal, setShowAddCardModal] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [coupon, setCoupon] = useState(""); // State to hold the coupon code
  const [isCouponApplied, setIsCouponApplied] = useState(false); // State to track coupon status

  const { cards, loading: cardLoading } = useSelector((state) => state.card);
  const { successMessage, errorMessage, taxRate, promoCode } = useSelector(
    (state) => state.cart
  );
  const { orderDetails } = useSelector((state) => state.order);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (step === 5) {
      let orderData = localStorage.getItem("orderData");
      if (orderData) {
        setCheckoutData(JSON.parse(orderData));
      }
      if (token) {
        let data = { page: 1, limit: 25 };
        dispatch(fetchUserCards(data));
      }
      dispatch(fetchTaxRate());
      dispatch(clearMessages());

      setCoupon("");
      setIsCouponApplied(false);
    }
  }, [token, step, dispatch]);

  useEffect(() => {
    if (cards?.data?.length > 0) {
      setSelectedCardId(cards.data[0].id); // Select first card by default
    }
  }, [cards]);

  useEffect(() => {
    if (promoCode !== null) {
      setIsCouponApplied(true);
    } else {
      setIsCouponApplied(false);
    }
  }, [promoCode]);

  useEffect(() => {
    if (orderDetails) {
      localStorage.removeItem("orderData");
      navigate("/profile/my-services");
    }
  }, [navigate, orderDetails]);

  // Handle coupon code input
  const handleCouponChange = (e) => {
    let input = e.target.value.toUpperCase(); // Convert input to uppercase
    // Only allow uppercase letters and digits
    const regex = /^[A-Z0-9]*$/;

    if (regex.test(input)) {
      setCoupon(input); // Update state if input is valid
    }
  };

  // Handle coupon submission
  const handleCouponSubmit = async (e) => {
    e.preventDefault();

    if (isCouponApplied) {
      // Clear the coupon
      setCoupon("");
      setIsCouponApplied(false);
    } else {
      try {
        let formData = { code: coupon };
        dispatch(fetchPromocode(formData));
      } catch (err) {
        toast.error("Failed to verify coupon code. Please try again.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages());
      dispatch(clearOrderMessages());
    }

    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages());
      dispatch(clearOrderMessages());
    }
  }, [successMessage, errorMessage, dispatch]);

  return (
    <>
      <div className="checkout-cart">
        <Row>
          <Col xl={8}>
            <div className="checkout-cart-box">
              <h3>Services</h3>
              <div className="checkout-list">
                <div className="checkout-item">
                  <h4>Service Name</h4>
                  <h4>Amount</h4>
                </div>

                {checkoutData?.services?.length > 0 && (
                  <>
                    {checkoutData?.services?.map((item, index) => (
                      <div className="checkout-item" key={"item-" + index}>
                        <div className="cart-box-content">
                          <span>{index + 1}</span>
                          <h2>{item.title}</h2>
                        </div>
                        <h4 className="price-value">
                          $ {formatPrice(item.price)}
                        </h4>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className="divider"></div>
              <div className="address-method">
                <h4>Payment Methods</h4>
                <div className="address-method-header">
                  <h5>Credit & Debit Card</h5>
                  {token ? (
                    <Link to="" onClick={() => setShowAddCardModal(true)}>
                      + Add New Card
                    </Link>
                  ) : (
                    <Link to="/register">+ Add New Card</Link>
                  )}
                </div>
                {!cardLoading && (
                  <div className="address-method-body p-2" key="k3">
                    {cards?.data?.length > 0 ? (
                      cards.data.map((row) => (
                        <div className="radio-group" key={`card_${row.id}`}>
                          <div className="gender-group payment-card-group">
                            <Form.Check
                              type="radio"
                              name="payment_method"
                              checked={selectedCardId === row.id}
                              className="form-check custom-checkbox"
                              id={`card-${row.id}`}
                              onChange={() => setSelectedCardId(row.id)}
                            />
                            <div className="radio-info">
                              <div className="card-info-box">
                                <img
                                  className="card-info-box-icon"
                                  src={
                                    row.card_type === "visa"
                                      ? Visa
                                      : row.card_type === "mastercard"
                                      ? MasterCard
                                      : row.card_type === "amex"
                                      ? AmericanExpress
                                      : row.card_type === "discover"
                                      ? Discover
                                      : row.card_type === "diners"
                                      ? AmericanExpress
                                      : row.card_type === "jcb"
                                      ? AmericanExpress
                                      : null
                                  }
                                  alt="Card"
                                />
                                <div className="card-info-box-text">
                                  <p>{row.card_name}</p>
                                  <p>**** **** **** {row.card_number}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="mb-0">No card found.</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>

          <Col xl={4}>
            <div className="coupon-code-box">
              <div className="box-header">
                <h3>Coupon Code</h3>
                <p>Unlock special savings on your next purchase!</p>
              </div>
              <div className="discount-code">
                <h4>Apply Discount Code</h4>
                <Form onSubmit={handleCouponSubmit}>
                  <Form.Group controlId="formCoupon">
                    <Form.Control
                      type="text"
                      placeholder="Enter Promo Code"
                      value={coupon}
                      onChange={handleCouponChange}
                    />
                  </Form.Group>
                  <Button type="submit" className="custom-bttn">
                    {isCouponApplied ? "Clear" : "Apply"}{" "}
                    {/* Toggle button text */}
                  </Button>
                </Form>
              </div>
              <CartSummary
                token={token}
                checkoutData={checkoutData}
                taxRate={taxRate}
                promoCode={promoCode}
                isCouponApplied={isCouponApplied}
                selectedCardId={selectedCardId}
                handleBack={handleBack}
              />
            </div>
          </Col>
        </Row>
      </div>

      <AddCardModal
        show={showAddCardModal}
        onHide={() => setShowAddCardModal(false)}
      />
    </>
  );
};

export default CheckoutComp;
